export const DeleteIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="9" stroke="#517FF5" strokeWidth="1.5" />
    <path d="M9 14.9997L15 8.99966" stroke="#517FF5" strokeWidth="1.5" />
    <path d="M15 15L9 9" stroke="#517FF5" strokeWidth="1.5" />
  </svg>
);
